import React from 'react';

import { Panel, PanelHeader, PanelHeaderBack, Spacing, Text, Title } from '@vkontakte/vkui';

import { PredictionLoading } from './components/PredictionLoading';
import styles from './ResultPanel.module.css';
import { ResultPanelProps } from './types';
import { HeaderContent } from '../../../../components/HeaderContent';
import { ResultContentPage } from '../../pages/ResultPage';

export const ResultPanel: React.FC<ResultPanelProps> = ({
  id,
  onBackClick,
  isDesktop,
  predictionVkId,
  userVkId,
  resultType
}) => {
  if (!predictionVkId) {
    return (
      <Panel id={id} className={styles.panel}>
        <PanelHeader before={isDesktop ? <PanelHeaderBack onClick={onBackClick}/> : <HeaderContent needBackIcon title="Назад" onClick={onBackClick}/>} separator={isDesktop}>
          {isDesktop && 'AI-профориентатор'}
        </PanelHeader>
        <Spacing size={4} />
        <Title style={{ textAlign: 'center' }}>
            Отсутствуют данные для предсказания 😞
        </Title>
        <Spacing size={8} />
        <Text style={{ textAlign: 'center' }}>
          Попробуйте выбрать пользователя еще раз
        </Text>
      </Panel>
    );
  }

  return (
    <Panel id={id} className={!resultType ? styles.panel : undefined}>
      <PanelHeader before={resultType ? (isDesktop ? <PanelHeaderBack onClick={onBackClick}/> : <HeaderContent needBackIcon title="Назад" onClick={onBackClick}/>) : undefined} separator={isDesktop}>
        {isDesktop && 'AI-профориентатор'}
      </PanelHeader>
      {     
        !resultType? (
          <PredictionLoading />
        ) : (
          <ResultContentPage
            onClick={() => {}}
            resultType={resultType}
            isOtherUserBeenPredicted={userVkId !== predictionVkId}
          />
        )
      }
    </Panel>
  );
};
